import { useEffect, useMemo, useRef, useState } from 'react';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import { debounce } from 'lodash';
import { useAlertsStore } from '../../../../../../stores/websocketStore/_alertsStore';

export const useAlertWatchlistComponent = (details, moduleId) => {
  const [selectedWatchlist, setSelectedWatchlist] = useState('default');
  const [selectedAlert, setSelectedAlert] = useState(null);
  const { layoutStore } = useWebsocketStore();
  const alertStore = useAlertsStore();
  const timeoutRef = useRef();
  const updateSelectedGroupData = (id, watchlist, store) => {
    const alert = store.alertTradePlansById[id] ?? null;
    const groupNumber =
      alertStore.alertTradePlansByWatchlistName[watchlist].groupNumber;
    layoutStore.setSelectedGroupData(groupNumber, { symbol: alert.symbol });
  };
  const debouncedFunction = useMemo(
    () => debounce(updateSelectedGroupData, 500),
    []
  );
  // when details prop changes, set the selected watchlist to the details.watchlistName
  useEffect(() => {
    if (details.watchlistName && details.watchlistName !== 'default') {
      if (!alertStore.alertTradePlansByWatchlistName[details.watchlistName]) {
        alertStore.addNewWatchlist(details.watchlistName);
      }
      setSelectedWatchlist(details.watchlistName);
    }
  }, [details.watchlistName]);
  
  // when another module is clicked on, unselected the current row
  useEffect(() => {
    if (layoutStore.currentFocusedModule !== moduleId)
      setSelectedAlert(null);
  }, [layoutStore.currentFocusedModule]);

  // when an alert is selected, set selected group data
  useEffect(() => {
    if (selectedAlert) {
      debouncedFunction(selectedAlert, selectedWatchlist, alertStore);
    }
  }, [selectedAlert]);

  //when selected watchlist changes, update the layout module
  useEffect(() => {
    if (
      selectedWatchlist !== 'default' &&
      selectedWatchlist !== undefined &&
      selectedWatchlist !== ''
    ) {
      layoutStore.updateCurrentLayoutModuleSelectedWatchlistName(
        'alerts',
        moduleId,
        selectedWatchlist
      );
      alertStore.setWatchlistGroupNumber(
        selectedWatchlist,
        details.groupNumber
      );
      layoutStore.updateServerCurrentLayout('alerts', 'currentAlerts');
    }
  }, [selectedWatchlist]);

  // when group number changes, set watchlist group number
  useEffect(() => {
    if (selectedWatchlist !== 'default') {
      alertStore.setWatchlistGroupNumber(
        selectedWatchlist,
        details.groupNumber
      );
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [details?.groupNumber]);

  return {
    selectedWatchlist,
    setSelectedWatchlist,
    selectedAlert,
    setSelectedAlert,
    alertStore,
    layoutStore,
  };
};
